<template>
  <div class="logout-btn" @click="logout">
    <feather-icon icon="PowerIcon" svgClasses="w-4 h-4" style="color: #fff" />
    <p class="ml-2">خروج از حساب کاربری</p>
  </div>
</template>

<script>
import authApiService from "../../services/api/AuthApiService";
import authService from "../../services/AuthService";

export default {
  name: "LogoutHeader",
  methods: {
    logout() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `خروج از حساب کاربری`,
        text: "از حساب کاربری خود خارج میشوید؟",
        acceptText: "بلی",
        cancelText: "خیر",
        accept: () => {
          this.$vs.loading();
          authApiService.logout().then(() => {
            authService.logout();
            location.reload();
          });
        },
      });
    },
  },
};
</script>

<style lang="scss">
.logout-btn {
  width: fit-content;
  display: flex;
  padding: 10px;
  cursor: pointer;
  border-radius: 5px;
  color: #fff;
  background-color: rgba(var(--vs-danger));
}
</style>
